<template>
    <v-flex xs12 :key="$router.currentRoute.fullPath">
        <v-card v-if="!assessmentResults">
            <v-card-title primary-title class="justify-center">
<!--                <div>-->
<!--                    <h3 class="display-4">{{currentQuestion ? currentQuestion.text : '?' }}</h3>-->
<!--                    <v-divider></v-divider>-->
<!--                    <v-radio-group-->
<!--                            class="justify-center"-->
<!--                            v-if="currentQuestion && currentQuestion.answerType === 'passfail'"-->
<!--                            v-model="answer" :mandatory="true">-->
<!--                        <v-radio label="Knows" :value="'pass'"></v-radio>-->
<!--                        <v-radio label="Doesn't know" :value="'fail'"></v-radio>-->
<!--                    </v-radio-group>-->
<!--                </div>-->

                <QuestionPassFailDisplay
                        v-if="currentQuestion && currentQuestion.answerType === 'passfail'"
                        v-model="answer"
                        :question="currentQuestion">
                </QuestionPassFailDisplay>
                <QuestionMultiChoiceDisplay
                        v-if="currentQuestion && currentQuestion.answerType === 'multichoice'"
                        v-model="answer"
                        :question="currentQuestion">
                </QuestionMultiChoiceDisplay>
            </v-card-title>

            <v-card-actions>
                <v-btn color="info"
                       :disabled="currentQuestionIndex === 0"
                       @click="prevQuestionOrNoop()">&lt;&lt; Prev</v-btn>
                <v-spacer></v-spacer>
                <span>{{currentQuestionIndex + 1}} / {{loadedQuestions ? loadedQuestions.length : '?'}}</span>
                <v-spacer></v-spacer>
                <v-btn color="info"
                       :disabled="forceReplyBeforeNext && !answer"
                       @click="nextQuestionOrFinish()">{{isLastQuestion() ? "Finish" : "Next"}} &gt;&gt;</v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
</template>

<script>
    import AssessmentHistoryChart from "./AssessmentHistoryChart";
    import QuestionPassFailDisplay from "@/components/QuestionPassFailDisplay.vue"
    import QuestionMultiChoiceDisplay from "@/components/QuestionMultiChoiceDisplay.vue"
    export default {
        components: {AssessmentHistoryChart, QuestionPassFailDisplay, QuestionMultiChoiceDisplay},
        data: function () {
            return {
                currentQuestionIndex: 0,
                answer: null,
                loadedQuestions: null,
                currentQuestion: null,
                assessmentMeta: null,
                // make empty object to prevent test from showing while data for summary is loading
                assessmentResults: this.$router.currentRoute.query['tab'] === 'summary' ? {} : null,
                forceReplyBeforeNext: this.$router.currentRoute.query['mustReplyBeforeNext'],
                studentId: +this.$router.currentRoute.params['studentId'],
                assessmentId: +this.$router.currentRoute.params['testId']
            }
        },

        computed: {
            assessmentInProgress: {
                get: function () {
                    return this.$store.state.assessmentsInProgress.find(
                        a => a.assessmentId === +this.$router.currentRoute.params['testId']);
                }
            },
            recordedAnswer: {
                get: function () {
                    let qId = this.currentQuestion.id;
                    let answer = (
                        this.assessmentInProgress &&
                        this.assessmentInProgress.answerMap &&
                        this.assessmentInProgress.answerMap.has(qId)) ?
                        this.assessmentInProgress.answerMap.get(qId).answer :
                        null;
                    return answer;
                },
            },
        },
        methods: {
            nextQuestionOrFinish() {
                if (this.currentQuestionIndex === this.loadedQuestions.length - 1) {
                    // Answered the last question!! Hooray!

                    this.recordCurrentAnswer();

                    this.$store.dispatch('finishTest', {
                        studentId: this.studentId,
                        assessmentId: this.assessmentInProgress.assessmentId
                    }).then((r) => {
                        // remove the test from history and replace it by the below test result summary
                        this.$router.replace({
                            name: 'test-summary-for-student',
                            params: {
                                historyId: r.id,
                            }
                        });
                    });
                }
                else {
                    this.recordCurrentAnswer();
                    this.currentQuestionIndex++; // move the pointer forward
                    this.currentQuestion = this.loadedQuestions[this.currentQuestionIndex];
                    this.answer = this.recordedAnswer; // get the recorded answer for the next question
                }
            },

            prevQuestionOrNoop() {
                if (this.answer) {
                    // the answer to the question we are navigation away from hasn't been saved. save it.
                    this.recordCurrentAnswer();
                }
                if (this.currentQuestionIndex > 0) {
                    this.currentQuestionIndex--;
                    this.currentQuestion = this.loadedQuestions[this.currentQuestionIndex];
                    this.answer = this.recordedAnswer;
                }
            },

            isLastQuestion() {
                return !this.loadedQuestions || this.currentQuestionIndex === this.loadedQuestions.length - 1;
            },
            recordCurrentAnswer() {
                this.$store.commit('answerQuestion', {
                    assessmentId: this.assessmentMeta.assessmentId,
                    studentId: this.studentId,
                    questionId: this.currentQuestion.id,
                    answer: this.answer
                });
            },
            navigateToStudentHistory() {
                this.$router.push({
                    name: 'test-history-chart',
                    query: {
                        studentId: this.studentId
                    }
                })
            }
        },
        mounted() {
            // get assessment and student data
            Promise.all([
                this.$store.dispatch('getAssessments', {
                    ids: [+this.$router.currentRoute.params['testId']]
                }),
                this.$store.dispatch('getStudents', { ids: [this.studentId] })])
            .then((results) => {
                if (!results || results.length !== 2) {
                    return Promise.reject('Unable to get student and/or test information');
                }
                let aList = results[0];
                let sList = results[1];

                if (!aList || !aList.length) {
                    return Promise.reject('Requested test wasn\'t found');
                }
                if (!sList || !sList.length) {
                    return Promise.reject('Requested student wasn\'t found');
                }
                this.assessmentMeta = aList[0];
                let student = sList[0];

                // set toolbar title
                this.$store.commit('setToolbarOptions', {
                    title: this.assessmentMeta.title,
                    subTitle: student.getFullName(),
                    hideSearch: true,
                    backButtonRoute: {name: 'test', params: {id: this.assessmentMeta.assessmentId}}
                });

                // load the questions
                this.$store.dispatch('getQuestions', {ids: this.assessmentMeta.questions.map(q => q.id)})
                    .then((qList) => {
                        this.loadedQuestions = qList;
                        this.currentQuestion = this.loadedQuestions[this.currentQuestionIndex];
                    });

                // start the test
                if (!this.assessmentInProgress) {
                    this.$store.commit('beginTest', {
                        testId: this.assessmentMeta.assessmentId,
                        studentId: this.studentId
                    });
                }
            });
        }
    }
</script>
